export const multiFilter = <T>(
  object: T,
  ...filters: Array<(object: T) => boolean>
): boolean => {
  return filters?.reduce(
    (keep: boolean, filter: (object: T) => boolean) => keep && filter(object),
    true
  );
};
